export class StringUtils {

    public static readonly allowedTags = "<p><strong><i><ol><li><ul><h2><h3><h4><u>";
    public static readonly spaceSeparatorChars = "_#_";
    public static readonly dotSeparatorChars = "_+_";
    public static readonly commaSeparatorChars = "_-,-_";
    public static readonly emptyArrayAsString = "[]";

    public static compareGuid(guid1: string,guid2: string){
        guid1 = guid1.replace(/[{}]/g,"").toLowerCase();
        guid2 = guid2.replace(/[{}]/g,"").toLowerCase();
        if(guid1 === guid2){
            return true;
        }
        return false;
    }
    public static unCamelise(str: string, index: number){
        const result = str.replace( /([A-Z0-9])/g, " $1" );
        const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
        let numberString = index.toString();
        let substring = finalResult.substring(finalResult.length - numberString.length);
        if (substring === numberString) {
            return finalResult.substr(0, finalResult.length - numberString.length);
        }
        return finalResult;
    }

    public static convertKeyToLabel(str: string, index: number){
        const spaceSeparatorChars = new RegExp(StringUtils.spaceSeparatorChars, "g");
        const dotSeparatorChars = new RegExp(StringUtils.dotSeparatorChars, "g");
        let result = str.replace( spaceSeparatorChars, " " );
        result = result.replace( dotSeparatorChars, "." );
        result = StringUtils.UnHtmlEntities(result);
        const finalResult = this.titleCaseAllWords(result);
        let numberString = index.toString();
        let substring = finalResult.substring(finalResult.length - numberString.length);
        if (substring === numberString) {
            return finalResult.substr(0, finalResult.length - numberString.length);
        }
        return finalResult;
    }

    public static titleCaseAllWords(sentence: string){
        const toTitleCase = (phrase: string) => {
            return phrase
                .toLowerCase()
                .split(' ')
                .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
        };
        return toTitleCase(sentence);
    }

    public static stripTags(htmlContent: string, allowedTags: string){
        allowedTags = (((allowedTags || '') + '')
            .toLowerCase()
            .match(/<[a-z][a-z0-9]*>/g) || [])
            .join(''); // making sure the allowed arg is a string containing only tags in lowercase (<a><b><c>)
        var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi,
            commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi;
        return htmlContent.replace(commentsAndPhpTags, '')
            .replace(tags, function($0, $1) {
                return allowedTags.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : '';
            });
    }

    public static UnHtmlEntities(str: string) {
        return String(str).replace(
            /&amp;/g,
            '&').replace(
                /&lt;/g,
            '<').replace(
                /&gt;/g,
            '>').replace(
                /&sol;/g,
            '/').replace(
                /&quot;/g,
            '"');
    }
}
